module.exports = __webpack_public_path__ + "img/30537bd.jpg";